// @ts-nocheck
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getBackOrders, GetBackOrdersApiParameter } from "@store/Framework/Services/BackOrderService";
import { BackOrderCollectionModel, BackOrderModel } from "@store/Framework/Types/ApiModels";

type HandlerType = ApiHandler<GetBackOrdersApiParameter, BackOrderCollectionModel>;

export const DispatchBeginLoadBackOrders: HandlerType = props => {
    props.dispatch({
        type: "Data/BackOrders/BeginLoadBackOrders",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    const apiResult = await getBackOrders(props.apiParameter);

    // for an ID for the dataview
    const backOrders = apiResult.backOrders ?? [];
    const cleaned: BackOrderModel[] = backOrders.map((item: BackOrderModel) => {
        const productId = item.product?.id ?? "";
        const originalOrderNumber = item.originalOrderNumber ?? "";
        const originalOrderDate = item.originalOrderDate ?? "";

        return {
            ...item,
            id: `${originalOrderNumber}${originalOrderDate}${productId}`,
        };
    });

    apiResult.backOrders = cleaned;

    props.apiResult = apiResult;
};

export const DispatchCompleteLoadBackOrders: HandlerType = props => {
    props.dispatch({
        type: "Data/BackOrders/CompleteLoadBackOrders",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadBackOrders,
    RequestDataFromApi,
    DispatchCompleteLoadBackOrders,
];

const loadBackOrders = createHandlerChainRunner(chain, "LoadBackOrders");
export default loadBackOrders;
